import React, { memo } from 'react'

import useIsClient from '../hooks/is-client'

const Icon = () => {
  const { isClient } = useIsClient()

  if (!isClient) {
    return <></>
  }

  return <></>
}

export default memo(Icon)
